









































































import { Component, Vue } from "vue-property-decorator";

@Component({
    name: "Navigation",
})
export default class Navigation extends Vue {
    public spin() {
        this.$emit("startSpin");
    }
}
